jQuery(document).ready(function(){


	setHeroRotatorMinHeight();
	hideMobileHeaderTopOnScroll();


	// bootstrap dropdowns custom behaviors
	//--------------------------------------------------------------------------------------------------


	// open dropdowns on hover
	if (jQuery(window).width() >= 1024) {
		jQuery('.dropdown').hover(function() {
			//jQuery(this).find('.dropdown-menu').first().stop(true, true).slideToggle(200);
		});
	}

	// Init jQuery UI accordions
	jQuery( '.accordion, .accordion-styled' ).accordion( {
		collapsible: true,
		active: false,
		heightStyle: 'content'
	});

	// AJAX request for the footer form
	jQuery( '#signup_submit').click( function( e ) {
		jQuery( '.has-error' ).removeClass( 'has-error' ).find( '.error_msg' ).remove();
		jQuery( '.form-message' ).children( 'div' ).remove();
		e.preventDefault();
		jQuery( '#signup_submit' ).html( 'Processing <span class="fa fa-spinner fa-spin ml-2"></span>' ).attr( 'disabled', 'disabled' );
		jQuery.ajax({
			url: document.location.origin + '/wp-admin/admin-post.php',
			type:'POST',
			data: jQuery( '#signup-form' ).serialize(),
			dataType: 'JSON',
			success: function( response ) {
				if ( ! response.is_valid ) {
					jQuery.each( response.validation_messages, function( k, v ) {
						switch ( k ) {
							case '1':
								jQuery( 'input[name="first_name"]' ).parent( '.form-group' ).addClass( 'has-error' );
								break;
							case '2':
								jQuery( 'input[name="last_name"]' ).parent( '.form-group' ).addClass( 'has-error' );
								break;
							case '3':
								jQuery( 'input[name="email"]' ).parent( '.form-group' ).addClass( 'has-error' );
								break;
						}
					});
					jQuery( '.form-message' ).html( '<div class="alert alert-danger">Please correct the errors hightlighted above in red.</div>' );
				} else {
					jQuery( '#signup-form' ).remove();
					jQuery( '.form-message' ).html( '<div class="text-center alert alert-success">' + response.confirmation_message + '</div>' );
				}
				jQuery( '#signup_submit' ).text( 'Submit' ).removeAttr( 'disabled' );
			}
		});
	});

	// Add slideDown animation to Bootstrap dropdown when expanding.
  jQuery('.dropdown').on('show.bs.dropdown', function() {
    jQuery(this).find('.dropdown-menu').first().stop(true, true).slideDown(200);
  });

  // Add slideUp animation to Bootstrap dropdown when collapsing.
  jQuery('.dropdown').on('hide.bs.dropdown', function() {
    jQuery(this).find('.dropdown-menu').first().stop(true, true).slideUp(200);
  });




	// on window scroll functions
	//--------------------------------------------------------------------------------------------------
	var lastScrollTop = 0;
	jQuery(window).on('scroll', function() {

		var st = jQuery(this).scrollTop();

		// shrink header on scroll
		if ( st > 100 ) {
			jQuery('header.main-header').removeClass('header-default').addClass('header-sticky');
		} else {
			jQuery('header.main-header').removeClass('header-sticky').addClass('header-default');
		}

		if ( st > 100 && st > lastScrollTop ) {
			jQuery( '.header-top-bar' ).removeClass( 'in' );
			jQuery( '.header-top-bar' ).addClass( 'fade past' );
			// jQuery( '.header-top-bar' ).fadeOut();
		} else {
			jQuery( '.header-top-bar' ).removeClass( 'past' );
			jQuery( '.header-top-bar' ).addClass( 'in' ).children( '.header-bar-inner' ).removeClass( 'hide' ) ;
			// jQuery( '.header-top-bar' ).fadeIn();
		}

		lastScrollTop = st;
	});



	// on window resize functions
	//--------------------------------------------------------------------------------------------------

  jQuery(window).resize(function(){
		setHeroRotatorMinHeight();
		hideMobileHeaderTopOnScroll();
	});

});




// homepage hero min height
// base the min-height of the homepage hero on the height of the tallest caption
function setHeroRotatorMinHeight() {
  var heroRotator = jQuery('#homepage-hero-rotator'),
			slideCaption = jQuery('.slide .slide-caption', heroRotator),
			slideCaptionBottom = parseInt(slideCaption.css('bottom')),
			rotatorContainer = jQuery('.rotator-wrapper');

	// Get an array of all slide caption heights
  var slideCaptionHeights = slideCaption.map(function() {
    return jQuery(this).height();
  }).get();

  // Math.max takes a variable number of arguments
  // `apply` is equivalent to passing each height as an argument
  var maxHeight = Math.max.apply(null, slideCaptionHeights);

  // Set rotator container to the max height plus a multiple of the value of the CSS bottom value
  rotatorContainer.css('min-height', (maxHeight + (slideCaptionBottom*3)));
}


// hide mobile header top bar on scroll (show on scroll up)
function hideMobileHeaderTopOnScroll() {

	if(jQuery(window).width() <= 1024) {
			var didScroll,
				lastScrollTop = 0,
				delta = 5,
				siteHeader = jQuery('header.main-header'),
				headerHeight = siteHeader.outerHeight();;

		// on scroll, let the interval function know the user has scrolled
		jQuery(window).scroll(function(event){
			didScroll = true;
		});

		// run hasScrolled() and reset didScroll status
		setInterval(function() {
			if (didScroll) {
				hasScrolled();
				didScroll = false;
			}
		}, 250);

		function hasScrolled() {
			var st = jQuery(this).scrollTop();

			// Make sure they scroll more than delta
			if(Math.abs(lastScrollTop - st) <= delta)
					return;

			// If they scrolled down and are past the navbar, add class .header-up.
			// This is necessary so you never see what is "behind" the navbar.
			if (st > lastScrollTop && st > headerHeight){
					// Scroll Down
					siteHeader.removeClass('header-down').addClass('header-up');
			} else {
					// Scroll Up
					if(st + jQuery(window).height() < jQuery(document).height()) {
							siteHeader.removeClass('header-up').addClass('header-down');
					}
			}

			lastScrollTop = st;
		}
	}
}
